import { methods } from '../../../../services/api/ApiConstants';
import remoteOralExamConstants from '../../../../constants/RemoteOralExamConstants';
import storeManager from '../../../../store/StoreManager';
import sessionReader from '../../../../store/readHelpers/SessionReader';

const callFrameSelector = {
    /**
     * liveDataLoader won't fetch Zoom test credentials when WebRTC test call
     * should be used.
     *
     * So it checks if credentials are provided to render Zoom instead of WebRTC
     * test call.
     */
    areValidCredentials(credentials) {
        return (
            !!credentials
            && Object.prototype.hasOwnProperty.call(credentials, 'meetingId')
            && Object.prototype.hasOwnProperty.call(credentials, 'password')
        );
    },

    selectFrameSrc(credentials) {
        let url;
        if (this.areValidCredentials(credentials)) {
            const { remoteOralExam: { sessionInfo } } = storeManager.getState();
            const { firstName, evaluatorFirstName } = sessionInfo;
            const zoomHuichangEnabled = sessionReader.isZoomHuichangEnabled();
            if (credentials?.sdkKey && credentials?.sdkKey?.trim()?.length > 0 && credentials?.sdkSignature?.trim()?.length > 0
                && !zoomHuichangEnabled) {
                url = `${methods.VCC}?isTT=true&meetingNumber=${credentials.meetingId}&password=${credentials.password}`
                + `&isZoomConnectionTest=true&token=${credentials.sdkKey}&signature=${credentials.sdkSignature}`;
            } else {
                url = `${methods.VCC}?isTT=true&meetingNumber=${credentials.meetingId}&password=${credentials.password}&isZoomConnectionTest=true`;
            }

            if (evaluatorFirstName) {
                url = `${url}&evaluatorFirstName=${evaluatorFirstName}`;
            }

            if (firstName) {
                url = `${url}&candidateFirstName=${firstName}`;
            }

            if (zoomHuichangEnabled) {
                url = `${url}&signature=${credentials.signature}&type=zoom_huichang`;
            }

            return url;
        }

        return remoteOralExamConstants.webRTCTestCallUrl;
    },

    mapPropsToProps({ credentials }) {
        return {
            frameSrc: this.selectFrameSrc(credentials),
        };
    },
};

export default callFrameSelector;
